<template>
  <div class="merchandiseCarousel">
    <div class="category_homepanel" v-if="trendingProductList && dataValue.length > 0 ">
      <h3 class="section_heading">{{title}}</h3>
      <div class="filter_product_list flx">
        <div
          class="filter_card fadeInUp"
          v-for="(product,index) in trendingProductList"
          :key="index"
          @click="goToProductDetail(product.saleReferenceID)"
        >
          <div class="img_wrapper">
            <img :src="product.displayImage" v-if="product.displayImage" alt="product" />
            <img src="../../assets/images/mall91_logo.jpg" alt="product_image" v-else />
          </div>
          <div class="product_detail">
            <div class="my_price_section">
              <span class="my_price">₹​ {{product.groupPrice}}</span>
              <span class="selling_price">₹​ {{product.markedPrice}}</span>
            </div>
            <span class="bought">
              <strong>{{product.peopleBought}}</strong>
              {{$t('peopleHaveBrought')}}
            </span>
          </div>
        </div>
      </div>
      <infinite-loading @infinite="getProductsListing" spinner="circles">
        <template slot="no-results">और रिकॉर्ड उपलब्ध नहीं है</template>
      </infinite-loading>
    </div>
    <div class="cntntLoad" v-if="cntntLoad">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ImageSpinner from "../Common/ImageSpinner";
import constant from "../../utils/constant";

export default {
  name: "TrendingProductList",
  components: {
    ImageSpinner
  },
  props: {
    title: {
      required: true,
      type: String
    },
    dataValue: {
      required: true,
      type: Array
    }
  },
  watch: {
    dataValue() {
      this.trendingProductList = this.dataValue;
    }
  },
  data() {
    return {
      trendingProductList: [],
      cntntLoad: false,
      pageIndex: 0
    };
  },
  methods: {
    getUserPrice(saleReferenceID, productDto) {
      this.cntntLoad = true;
      this.$store
        .dispatch({
          type: "getUserPriceProduct",
          payload: saleReferenceID
        })
        .then(data => {
          productDto.sellingPrice = data.data.totalPaidAmount;
          this.cntntLoad = false;
        })
        .catch(err => {
          this.cntntLoad = false;
          productDto.sellingPrice = productDto.groupPrice;
          console.log(err);
        });
    },
    goToProductDetail(productSrId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push({
        path: "/detail/" + productSrId
      });
      if (this.$props.title == this.$t("relatedProduct")) {
        this.$router.go({
          path: "/detail/" + productSrId
        });
      }
    },
    getProductsListing($state) {
      if (this.pageIndex == 0) {
        this.pageIndex = 1;
      }
      this.cntntLoad = true;
      this.$store
        .dispatch({
          type: "getProductType",
          payload: "PRODUCT?page=" + this.pageIndex
        })
        .then(data => {
          this.cntntLoad = false;
          if (
            data.data.merchandiseCarouselProductDTOs[0].merchandiseProductDTOs
              .length > 0
          ) {
            this.trendingProductList.push(
              ...data.data.merchandiseCarouselProductDTOs[0]
                .merchandiseProductDTOs
            );
            // this.$store.commit("saveTrendingListById", {
            //   trendingListById: this.trendingProductList,
            //   trendingListByIndex: this.pageIndex
            // });
            this.pageIndex += 1;
            $state && $state.loaded();
          } else {
            $state && $state.complete();
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted(){
    //  if (
    //     this.$store.getters.trendingListById &&
    //     this.$store.getters.trendingListById.length > 0 &&
    //     this.$store.getters.trendingListByIndex
    //   ) {
    //     this.trendingProductList = this.$store.getters.trendingListById;
    //     this.pageIndex = this.$store.getters.trendingListByIndex;
    //   }
  }
};
</script>
